import { render, staticRenderFns } from "./SSSContributionMain.vue?vue&type=template&id=09c147ff"
import script from "./SSSContributionMain.vue?vue&type=script&lang=js"
export * from "./SSSContributionMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports